import React from "react";
import { Button, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
const { Title } = Typography;

const ModalHeader = (props) => {
  const { hide, mode } = props;
  return (
    <div className="modalHeader">
      <div
        style={{ display: "flex", alignItems: "center", paddingRight: "10px" }}
      >
        {mode === "edit" ? (
          <Title level={5} style={{ margin: "0px" }}>
            {<FormattedMessage id="app.house_visits.editVisitTitle" />}
          </Title>
        ) : (
          <Title level={5} style={{ margin: "0px" }}>
            {<FormattedMessage id="app.house_visits.newVisitTitle" />}
          </Title>
        )}
      </div>
      <div>
        <Button
          className="closeBtn"
          type="text"
          shape="circle"
          icon={<CloseOutlined />}
          onClick={hide}
        />
      </div>
    </div>
  );
};

export default ModalHeader;
